const ngoData = [
  {
    id: 1,
    image: "https://res.cloudinary.com/dzbdnlr0f/image/upload/v1641630204/zete/smile_fopundation_ngo_xevkaq.png",
    name: "Smile Foundation",
    location: "Delhi",
  },
  {
    id: 2,
    image: "https://res.cloudinary.com/dzbdnlr0f/image/upload/v1641630204/zete/goonj_ngo_o59nqa.png",
    name: "Goonj",
    location: "Lucknow",
  },
  {
    id: 3,
    image: "https://res.cloudinary.com/dzbdnlr0f/image/upload/v1641630204/zete/pratham_ngo_mw4iqs.png",
    name: "Pratham",
    location: "Chennai",
  },
  {
    id: 4,
    image: "https://res.cloudinary.com/dzbdnlr0f/image/upload/v1641630204/zete/give_india_ngo_qxo4jt.png",
    name: "Give India",
    location: "Bombay",
  },
  {
    id: 5,
    image: "https://res.cloudinary.com/dzbdnlr0f/image/upload/v1641630204/zete/ngo1_i9hhvc.png",
    name: "Help Age",
    location: "Noida",
  },
  {
    id: 6,
    image: "https://res.cloudinary.com/dzbdnlr0f/image/upload/v1641630203/zete/cry_ngo_xpp5xw.png",
    name: "Cry Ngo",
    location: "Hyderabad",
  },
];

export default ngoData;
